import React from 'react';
import PropTypes from 'prop-types';
import MainSection from './MainSection';
import NewTabIcon from '../../../common/icons/NewTabIcon';
import { isFuturePublish } from '../helpers/timeHelpers';

const ManageLinks = ({ pressRelease, siteList }) => {
  const purchasedSites = pressRelease.crosspost_sites;
  const findSite = (siteId) => siteList.find((site) => site.site_id === siteId);
  const purchasedSitesList = purchasedSites.map(findSite);
  const {
    title,
    url,
    publish_date: publishedDateRaw,
    submitted_date: submittedDateRaw,
  } = pressRelease;
  const publishedDate = publishedDateRaw
    ? new Date(publishedDateRaw).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
    : new Date(submittedDateRaw).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  const publishMessageString = isFuturePublish(publishedDateRaw) ? `Publishing on ${publishedDate}` : `Published on ${publishedDate}`;

  return (
    <MainSection title="Press release link">
      <p className="explanation-text" style={{ marginTop: '-16px', marginBottom: '1.5rem' }}>
        Your edits will be reflected on the following press releases:
      </p>
      <ul className="press-release-links">
        {purchasedSitesList.map((site) => (
          <li key={site.site_id} className="press-release-link-item">
            <div className="site-name">
              {site.site_name}
            </div>
            <div className="press-release-content">
              <a
                href={`https://${site.site_domain}${url}`}
                className="press-release-title-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {title}
                <NewTabIcon size={16} color="#323239" />
              </a>
              <div className="published-date">
                {publishMessageString}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </MainSection>
  );
};

const PressReleaseObject = PropTypes.shape({
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  publish_date: PropTypes.string,
  submitted_date: PropTypes.string,
  crosspost_sites: PropTypes.arrayOf(PropTypes.string).isRequired,
});

const SiteObject = PropTypes.shape({
  site_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  site_name: PropTypes.string.isRequired,
  site_domain: PropTypes.string.isRequired,
});

ManageLinks.propTypes = {
  pressRelease: PressReleaseObject.isRequired,
  siteList: PropTypes.arrayOf(SiteObject).isRequired,
};

export default ManageLinks;
